import {ComponentProps, FC, forwardRef} from 'react';
import Icon from 'components/Icon';
import IconDocument from 'components/IconColor/32px/ml_document';
import SortableHandler from 'components/Sortable/SortableHandle';
import TooltipWrapper from 'components/Tooltip';
import {useTooltip} from 'components/Tooltip/hook';
import {t} from 'ttag';
import VerticalDots from '../VerticalDots';

const IconWithTooltip: FC<ComponentProps<typeof Icon>> = (props) => {
    const {setTooltipRef} = useTooltip();

    return <Icon ref={setTooltipRef} {...props} />;
};

export type SupersendDocumentProps = {
    datePaid?: string;
    dateSent?: string;
    dateSentByPost?: string;
    dateViewed?: string;
    displayName: string;
    isEditing?: boolean;
    mid: string;
    shouldDisplayNotViewed?: boolean;
    shouldDisplayNotYetSendbypost?: boolean;
    total?: string;
};

const SupersendDocument = forwardRef<HTMLDivElement, SupersendDocumentProps>(
    (
        {
            datePaid,
            dateSent,
            dateSentByPost,
            dateViewed,
            displayName,
            isEditing,
            mid,
            shouldDisplayNotViewed,
            shouldDisplayNotYetSendbypost,
            total,
        },
        ref,
    ) => (
        <div
            ref={ref}
            className="flex items-start p-2 gap-1 rounded border border-grey-400 bg-grey-100 w-fit"
        >
            <div className="flex h-full min-h-full items-center gap-1">
                {isEditing && (
                    <SortableHandler id={mid}>
                        <VerticalDots />
                    </SortableHandler>
                )}
                <IconDocument />
            </div>
            <div className="flex flex-col text-xs">
                <div className="flex flex-col gap-1">
                    <span className="flex gap-0.5">
                        {displayName && <span>{displayName}</span>}
                        {datePaid && (
                            <TooltipWrapper message={t`Paid: ${datePaid}`}>
                                <IconWithTooltip
                                    icon="checkmark_small"
                                    id="datePaid"
                                    size="base"
                                />
                            </TooltipWrapper>
                        )}
                        {dateSent && (
                            <TooltipWrapper message={t`Sent: ${dateSent}`}>
                                <IconWithTooltip
                                    icon="send_complete"
                                    id="dateSent"
                                    size="base"
                                />
                            </TooltipWrapper>
                        )}
                        {dateViewed && (
                            <TooltipWrapper message={t`Viewed: ${dateViewed}`}>
                                <IconWithTooltip
                                    icon="show"
                                    id="dateViewed"
                                    size="base"
                                />
                            </TooltipWrapper>
                        )}
                        {shouldDisplayNotViewed && (
                            <TooltipWrapper message={t`Not Viewed`}>
                                <IconWithTooltip
                                    icon="hide"
                                    id="notViewed"
                                    size="base"
                                />
                            </TooltipWrapper>
                        )}
                        {dateSentByPost && (
                            <TooltipWrapper
                                message={t`Sent by Japan Post: ${dateSentByPost}`}
                            >
                                <IconWithTooltip
                                    icon="mail_point"
                                    id="dateSentByPost"
                                    size="base"
                                />
                            </TooltipWrapper>
                        )}
                        {shouldDisplayNotYetSendbypost && (
                            <TooltipWrapper message={t`Not Yet Sent`}>
                                <IconWithTooltip
                                    icon="mail_point"
                                    id="notYetSendByPost"
                                    size="base"
                                />
                            </TooltipWrapper>
                        )}
                    </span>
                </div>
                {total && <span>{t`Total : ${total}`}</span>}
            </div>
        </div>
    ),
);
SupersendDocument.displayName = 'SupersendDocument';
export default SupersendDocument;
